(function($) {
    const selectOfficeLevel = () => {
        const $page = $('body.select-office-level')
        const $offSiteCheckbox = $page.find('#apply_off_site')

        $offSiteCheckbox.on('change', function(e) {
            const checked = e.target.checked
            const $next = $(this).closest('div').find('+ div')
            $next.toggleClass('d-none')
        })
    }

    $(function() {
        selectOfficeLevel()
    })
})(jQuery);
